import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/shui",
    name: "Shui",
    component: () => import("@/View/Shui.vue"),
  },
  {
    path: "/",
    name: "Framework",
    redirect: { name: "Shui" },
    component: () => import("@/View/Framework.vue"),
    children: [
      {
        path: "/jia",
        name: "Jia",
        component: () => import("@/View/Jia.vue"),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "/yi",
        name: "Yi",
        component: () => import("@/View/Yi.vue"),
      },
    ],
  },
  {
    path: "/jiaMenu",
    name: "JiaMenu",
    component: () => import("@/View/JiaMenu.vue"),
    props: (route) => {
      return {
        tiId: route.query.tiId,
        title: route.query.title,
      };
    },
  },
  {
    path: "/jiaImage",
    name: "JiaImage",
    component: () => import("@/View/JiaImage.vue"),
    props: (route) => {
      return {
        tiId: route.query.tiId,
        type: route.query.type,
        menuTitle: route.query.menuTitle,
      };
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const originalReplace = router.push;

router.push = async function push(location) {
  try {
    return await originalReplace.call(this, location);
  } catch (e) {
    if (
      !e.message.startsWith("Avoided redundant navigation to current location:")
    ) {
      throw e;
    }
  }
};
router.replace = async function replace(location) {
  try {
    return await originalReplace.call(this, location);
  } catch (e) {
    if (
      !e.message.startsWith("Avoided redundant navigation to current location:")
    ) {
      throw e;
    }
  }
};

export default router;
